import React, { type ReactNode } from 'react';
import { type LucideIcon } from 'lucide-react';

export function SectionContainer({
	title,
	TitleIcon,
	headerRightSlot,
	children
}: {
	title: string;
	TitleIcon?: LucideIcon;
	headerRightSlot?: ReactNode;
	children: ReactNode;
}) {
	return (
		<div className="rounded-xl border border-gray-200 bg-white shadow-sm">
			{!headerRightSlot ? (
				<div className="flex items-center gap-2 border-b border-gray-200 p-4">
					{TitleIcon && <TitleIcon className="size-5 text-primary-500" />}
					<h2 className="text-lg font-semibold text-gray-900">{title}</h2>
				</div>
			) : (
				<div className="flex items-center justify-between border-b border-gray-200 p-4">
					<div className="flex items-center gap-2">
						{TitleIcon && <TitleIcon className="size-5 text-primary-500" />}
						<h2 className="text-lg font-semibold text-gray-900">{title}</h2>
					</div>
					{headerRightSlot}
				</div>
			)}

			{children}
		</div>
	);
}
